// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"3da98719","377":"7d27e151","417":"b72f1b19","467":"6f3ff156","626":"e5e40771","870":"07b20258"}[chunkId] + ".js";
};